<template>
  <Transition name="gmf-sticky-toast-anim" appear>
    <div class="gmf-sticky-toast gmf-context">
      <div class="gmf-sticky-toast-content gmf-clickable" :class="{'gmf-use-3d-avatar': use3DAvatar}" @click.stop="clickHandler">
        <template v-if="toast.type === 'pinned-post'">
          <Avatar :customer="toast.comment.author" disablePopup disableOnlineIndicator animated />
          <div v-if="toast.comment.content.title" class="gmf-sticky-toast-text gmf-sticky-toast-title">
            <strong class="gmf-text-small">{{ title }}</strong>
            <span class="gmf-text-small">{{ text }}</span>
          </div>
          <span v-else class="gmf-text-small" v-max-lines:ellipsis="2">{{ text }}</span>
        </template>
      </div>

      <div class="gmf-sticky-toast-close">
        <Icon icon="modal-close" class="gmf-sticky-toast-close-btn gmf-clickable" @click="close"/>
      </div>
    </div>
  </Transition>
</template>

<style>
.gmf-sticky-toast {
  width: 100%;
  max-width: 500px;
  background: var(--gmf-sticky-toast-color);
  display: flex;
  align-items: center;
  gap: var(--gmf-p-2);
  border-radius: 40px;
  padding-left: 5px;
  padding-right: var(--gmf-p-4);
  margin: var(--gmf-p-3);
}
.gmf-sticky-toast-content {
  flex-grow: 1;
  display: flex;
  gap: var(--gmf-p-2);
  align-items: center;
}
.gmf-context .gmf-sticky-toast-content .gmf-text-small {
  color: var(--gmf-sticky-toast-text-color);
}
.gmf-context .gmf-sticky-toast-content strong.gmf-text-small {
  font-weight: bold;
}
.gmf-sticky-toast-content .gmf-avatar {
  width: 64px;
  height: 64px;
  margin: 6px;
  flex-shrink: 0;
  margin-left: 2px;
}
.gmf-sticky-toast-content.gmf-use-3d-avatar .gmf-avatar {
  margin: unset;
  margin-bottom: 3px;
}
.gmf-sticky-toast-content.gmf-use-3d-avatar .gmf-avatar-content {
  border-radius: 0 0 0 42px;
}
.gmf-sticky-toast-title .gmf-text-small {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gmf-sticky-toast-text {
  display: grid;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
  width: 100%;
}
.gmf-sticky-toast-content .gmf-avatar-3d {
  background: none;
}
.gmf-sticky-toast-close {
  display: flex;
  height: 100%;
  align-items: center;
}
.gmf-sticky-toast-close-btn {
  background: var(--gmf-col-white);
  border-radius: 100%;
  padding: calc(var(--gmf-p-2) + var(--gmf-p-1));
  width: 28px;
  height: 28px;
}

.gmf-sticky-toast-anim-enter-active,
.gmf-sticky-toast-anim-leave-active {
  transition: all 0.15s linear;
}

.gmf-sticky-toast-anim-enter-from,
.gmf-sticky-toast-anim-leave-to {
  transform: translateY(40px);
  opacity: 0;
}
</style>

<script>
import state from '@/state';
import Icon from '@/components/Icon.vue';
import Avatar from '@/components/Avatar.vue';

import maxLines from '@/utils/directives/maxLines';
import openPostModal from '@/widgets/PostModal/openPostModal';

export default {
  props: {
    toast: {
      type: Object,
      default: () => {},
    },
    close: {
      type: Function,
      default: () => {},
    }
  },
  components: {
    Icon,
    Avatar,
  },
  directives: {
    'max-lines': maxLines,
  },
  methods: {
    clickHandler() {
      if (this.toast.type === 'pinned-post') {
        openPostModal(this.toast.comment.id);
      }
      this.close();
    }
  },
  computed: {
    title() {
      if (this.toast.comment && this.toast.comment?.translation && this.shouldTranslate) {
        return this.toast.comment.translation.title;
      }

      return this.toast.comment.content.title;
    },
    text() {
      if (this.toast.comment && this.toast.comment?.translation && this.shouldTranslate) {
        return this.toast.comment.translation.text;
      }

      return this.toast.comment.content.text;
    },
    shouldTranslate() {
      return state.merchantConfig?.widgets?.translations.mode !== 'translateNothing';
    },
    use3DAvatar () {
      return state.merchantConfig.avatars.enabled === '3D';
    },
  }
};
</script>
